import { Filter, FilterProps } from '@otp/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getFilterConfig } from './config';
import { useQuery } from '@apollo/client';
import {
  StoresTemplateAssignmentDocument,
  StoresTemplateAssignmentQuery,
  WttpTemplatesLightDocument,
  WttpTemplatesLightQuery,
} from 'src/graphql/generated/graphql';

export const StoresFilter = (props: Omit<FilterProps, 'items'>) => {
  const { t } = useTranslation();

  // needed to fill the stores filter with all available store ids
  const { data: storesData } = useQuery<StoresTemplateAssignmentQuery>(
    StoresTemplateAssignmentDocument,
    {
      variables: {
        pagination: {
          limit: 200,
          offset: 0,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );
  const stores = storesData?.stores?.records || [];

  const { data: templatesData } = useQuery<WttpTemplatesLightQuery>(
    WttpTemplatesLightDocument,
    {
      variables: {
        filter: {
          isActive: true,
        },
        pagination: {
          limit: 200,
          offset: 0,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );
  const templates = templatesData?.wttpTemplates?.records || [];

  const filterConfig = getFilterConfig({ t, templates, stores });

  return (
    <div className="flex justify-between">
      <Filter
        {...props}
        items={filterConfig}
        searchInputProps={{
          placeholder: t('wttp.template.list.filter.search.placeholder'),
        }}
      />
    </div>
  );
};
